import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useApi } from 'api/api-context';
import BookingAccountLayout from 'pages/booking/account/BookingAccountLayout';
import { AccountError, AccountSkeleton } from 'pages/booking/account/account-utils';
import useLang from 'lang';

/**
 * Inline PDF preview backed by an authenticated blob request.
 */
export default function AccountInvoicePreview() {
  const { invoiceId } = useParams<{ invoiceId: string }>();
  const { getAction } = useApi();
  const { _t } = useLang();
  const [url, setUrl] = useState<string | null>(null);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    let active = true;
    let objectUrl: string | null = null;
    setError(false);
    getAction('GetMyReservationInvoicePdf')({ parameters: { invoiceId: Number(invoiceId) } })
      .then((blob) => {
        if (!active) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch(() => {
        if (active) setError(true);
      });
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [getAction, invoiceId, retry]);

  return (
    <BookingAccountLayout>
      <h2 className="account-section-title">{_t('Invoice preview')}</h2>
      {!url && !error && <AccountSkeleton />}
      {error && <AccountError retry={() => setRetry((value) => value + 1)} />}
      {url && <iframe className="account-pdf" title={_t('Invoice preview')} src={url} />}
    </BookingAccountLayout>
  );
}
